import { render, staticRenderFns } from "./CreateQuestionCategoryModal.vue?vue&type=template&id=4ced2674&"
import script from "./CreateQuestionCategoryModal.vue?vue&type=script&lang=js&"
export * from "./CreateQuestionCategoryModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports